import axios from '../../axios';
import {
   ADD_DAYBOOK,
   UPDATE_DAYBOOK,
   DELETE_DAYBOOK,
   GET_DAYBOOK,
   GET_DAYBOOKS,
   GET_DAYBOOKS_FOR_MASTER,
   GET_DAYBOOKS_FOR_PAYMENTS,
   GET_ISSUE_DAYBOOK,
   GET_ONE_DAYBOOK,
   GET_PAYMENT_DAYBOOK,
   GET_ALL_DAYBOOKS,
   MULTI_DELETE_DAYBOOK,
} from '../types';
import { toast } from 'react-toastify';

export const getDaybook = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DAYBOOKS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getDaybookForMaster = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DAYBOOKS_FOR_MASTER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getAllDaybooks = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ALL_DAYBOOKS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getPaymentDaybook = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_PAYMENT_DAYBOOK,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getDaybookForPayments = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DAYBOOKS_FOR_PAYMENTS,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getIssueDaybook = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_ISSUE_DAYBOOK, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const addDaybook = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/daybook/add', formData);

      if (res.data.code === 1) {
         localStorage.setItem('daybook', res.data.data.id);
         dispatch({ type: ADD_DAYBOOK, payload: res.data.data });
         toast.success('Daybook added successfully!');
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // toast.error('Failed to add daybook. Please try again.');
   }
};

export const updateDaybook = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/daybook/update', formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_DAYBOOK, payload: res.data.data });

         setTimeout(() => {
            toast.success('Daybook updated successfully!');
         }, 1000);
      } else {
         toast.error('Failed to update daybook. Please try again.');
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // toast.error('Failed to update daybook. Please try again.');
   }
};

export const deleteDaybook = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/daybook/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_DAYBOOK, payload: { id } });
         toast.success('Daybook deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Daybook. Please try again.');
   }
};

export const multiDeleteDaybook = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/daybook/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_DAYBOOK, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const updateStatus = (data) => async (dispatch) => {
   const res = await axios.post('/daybook/update/status', data);
   if (res.data.code === 1) {
      dispatch({ type: UPDATE_DAYBOOK, payload: res.data.data });
      toast.success('Status updated successfully!');
   }
   if (res.data.code === 2) {
      toast.warn(res.data.message);
   }
   return res.data.code;
};

export const updateDaybookIsOld = (data) => async (dispatch) => {
   const res = await axios.post('/daybook/update/isOld', data);
   if (res.data.code === 1) {
      dispatch({ type: UPDATE_DAYBOOK, payload: res.data.data });
      toast.success('Daybook updated successfully!');
   }
   if (res.data.code === 2) {
      toast.warn(res.data.message);
   }
   return res.data.code;
};

export const getDaybookById = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/daybook/id', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_DAYBOOK, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getSingleDaybook = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/daybook/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_DAYBOOK, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
